<template lang='pug'>
  .open-source
    website-spacing.whitespace
      v-row(justify='center').open-source-item
        v-col
          .display-2.pa-4.white--text.text-center Open-Source
          .headline.pa-4.white--text.text-center We build on top of the best open-source tools. We’re not a proprietary test solution.
      v-row(justify='center').open-source-item
        v-img(src='https://assets.bionicmetrics.com/bionic/openSource.png')
      v-row(justify='center').open-source-item
        .headline.pa-4.white--text.text-center We don’t reinvent the wheel. Instead we build on top of the best open-source tools and provide you a platform so you can focus on your application, not on building a test platform.
</template>

<script>
import WebsiteSpacing from './WebsiteSpacing';

export default {
  name: 'OpenSource',
  components: {WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .open-source {
    background-color: #263238;
  }

  .whitespace {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
</style>
